const ALL_OAUTH_TENANT_PROVIDERS = [
    'github',
    'hubspot',
    'slack'
];
const getMethodFromProvider = (provider)=>`${provider}_oauth`;

export { ALL_OAUTH_TENANT_PROVIDERS, getMethodFromProvider };
//# sourceMappingURL=oAuthProviders.mjs.map
